// Proforma Invoice (Proforma Quote) form. Thin wrapper around the shared
// DeliveryNoteForm — see that file for the actual form logic. Only the
// document type differs here; keep this file thin rather than duplicating
// form code (that duplication is exactly what this wrapper replaced — this
// page used to be a byte-for-byte clone of ProformaInvoice.jsx).
import DeliveryNoteForm from "../shared/DeliveryNoteForm.jsx";

const ProformaQuote = () => <DeliveryNoteForm variant="proforma" />;

export default ProformaQuote;
